// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__11pqV","large":"styles_large__1ashS"};